"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "genzano-di-roma": {
    "028311a5": [{
      "hkey": "6f6175d8",
      "slug": "landi-pedica",
      "name": "Landi-Pedica",
      "primary": true,
      "skipSearch": false
    }],
    "landi": [{
      "hkey": "6f6175d8",
      "slug": "landi-pedica",
      "name": "Landi-Pedica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ca733684": [{
      "hkey": "187742e6",
      "slug": "genzano-di-roma",
      "name": "Genzano di Roma",
      "primary": true,
      "skipSearch": false
    }],
    "vigne-nuove": [{
      "hkey": "187742e6",
      "slug": "genzano-di-roma",
      "name": "Genzano di Roma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd5d2a2b": [{
      "hkey": "187742e6",
      "slug": "genzano-di-roma",
      "name": "Genzano di Roma",
      "primary": true,
      "skipSearch": false
    }],
    "san-gennaro": [{
      "hkey": "187742e6",
      "slug": "genzano-di-roma",
      "name": "Genzano di Roma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;